import { useEffect, useContext } from 'react';
import { useNavigate, Outlet } from 'react-router';

import { ClinicRxContext } from './App';

export default function ProtectedRoute({}) {
  const navigate = useNavigate();
  const { state } = useContext(ClinicRxContext);

  useEffect(() => {
    if (!state.user.isAuthenticated) {
      navigate('/');
    }
  }, [state.user]);

  if (!state.user.isAuthenticated) return null;
  return <Outlet />;
}
